import { ButtonColor } from "@/common/enum/button-color";
import { Button } from "flowbite-react";
import { AngleRightOutlineIcon } from "../icon/AngleRightlineIcon";
import { BookOpenOutlineIcon } from "../icon/BookOpenOutlineIcon";
import { FolderOutlineIcon } from "../icon/FolderOutlineIcon";
import { InfoCircleOutlineIcon } from "../icon/InfoCircleOutlineIcon";
import { Body14Medium } from "../typography/Body14Medium";
import { Footnote12Description } from "../typography/Footnote12Description";
import { H5 } from "../typography/H5";

const ICON_SIZE = 20;
const ICON_COLOR = "text-primary-gray";

const data = [
  {
    id: 1,
    icon: <BookOpenOutlineIcon size={ICON_SIZE} color={ICON_COLOR} />,
    title: "파트너 교육신청",
    subTitle: "IoT 비즈니스를 운영하는데 필요한 지식을 배워보세요.",
    buttonDescription: "아카라 아카데미",
    link: "https://aqaralife.gitbook.io/academy/master/application",
  },
  {
    id: 2,
    icon: <InfoCircleOutlineIcon size={ICON_SIZE} color={ICON_COLOR} />,
    title: "파트너 도움말/FAQ",
    subTitle: "제품 설치,시공 방법과 고객 응대를 배울 수 있습니다.",
    buttonDescription: "제품 통합 메뉴얼",
    link: "https://aqaralife.gitbook.io/techhub",
  },
  {
    id: 3,
    icon: <InfoCircleOutlineIcon size={ICON_SIZE} color={ICON_COLOR} />,
    title: "발주몰 사용 가이드",
    subTitle: "사업자를 위한 발주몰 사용 방법을 확인할 수 있습니다.",
    buttonDescription: "발주몰 사용 가이드",
    link: "https://aqaralife.gitbook.io/partner-guide",
  },
  {
    id: 4,
    icon: <FolderOutlineIcon size={ICON_SIZE} color={ICON_COLOR} />,
    title: "아카라 자료실 ",
    subTitle: "비즈니스 관련 자료를 확인할 수 있습니다.",
    buttonDescription: "아카라 자료실",
    link: "https://aqaralife.gitbook.io/archive",
  },
];

export const PartnerBuisinessGuideSimplePanel = () => {
  const handleClick = (link: string) => {
    if (link) {
      window.open(link, "_blank");
    }
  };

  return (
    <div className="flex gap-[12px]">
      {data.map((item) => (
        <div
          key={item.id}
          className="flex flex-col justify-between p-[16px] border-[1px] border-semantic-divider rounded-[4px] w-[168px] h-[226px] bg-primary-white"
        >
          <div className="flex flex-col gap-[12px]">
            {item.icon}
            <H5 className="text-primary-dark-gray whitespace-break-spaces">
              {item.title}
            </H5>
            <Footnote12Description className="text-primary-dark-gray whitespace-break-spaces">
              {item.subTitle}
            </Footnote12Description>
          </div>
          <Button
            size="sm"
            color={ButtonColor.CUSTOM_GRAY}
            onClick={() => handleClick(item.link)}
          >
            <div className="flex items-center justify-center text-grayscale-contrast-80 gap-[8px]">
              <Body14Medium>{item.buttonDescription}</Body14Medium>
              <AngleRightOutlineIcon size={16} />
            </div>
          </Button>
        </div>
      ))}
    </div>
  );
};
